import { useMemo } from "react";
import Markdown from "../Markdown.jsx";
import { renderTemplate } from "../../lib/markdownTemplate.js";
import { KernelEmpty } from "./shared.jsx";

export const kind = "markdown";

// Narrative render primitive: a deterministic template (interpolation,
// {{#each}}, {{#if}}) projected over the renderSource step's data, then
// displayed through the same Markdown renderer the chat uses. This is
// the "the answer was prose, not a chart" path — it lets an analysis a
// model would otherwise type out become a re-runnable kernel.
//
// Because it carries prose the model would otherwise have written into the
// transcript, it is the one primitive that takes the chat's `linkifyText`
// hook - the same one AssistantNode passes, so session ids are clickable
// wherever the answer lands. Absent (saved kernels, the activity surface),
// ids stay plain text.
export function Component({ spec, data, linkifyText }) {
    const text = useMemo(() => {
        try {
            return renderTemplate(spec?.template || "", data);
        } catch {
            // A malformed template shouldn't crash the surface — degrade
            // to a visible error the same way unknown kinds do.
            return null;
        }
    }, [spec?.template, data]);

    if (text == null) {
        return <KernelEmpty message="markdown template failed to render" />;
    }
    if (!text.trim()) {
        return <KernelEmpty message={spec?.empty || "no content"} />;
    }

    return (
        <div className="text-[12px] leading-[1.5] text-[color:var(--ink)]">
            {spec?.title ? (
                <div className="mb-[6px] text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)]">
                    {spec.title}
                </div>
            ) : null}
            <Markdown text={text} linkifyText={linkifyText} />
        </div>
    );
}
